import styled from 'styled-components';

export const StyledStatusLightsZonesButton = styled.button`
  background-color: transparent;
  border: none;
  border-radius: 5px;
`;
